export const filters = {
	searchPlaceholder: "Buscar productos...",
	clearSearch: "Limpiar búsqueda",
	allProducts: "Todos los productos",
	activeProducts: "Productos activos",
	inactiveProducts: "Productos inactivos",
	viewByCategory: "Ver por Categoría",
	viewByMenuCategory: "Ver por Categoría de Menú",
	clearFilters: "Limpiar filtros",
};
